export default function setHost() {
  let port = document.location.port;
  let o;
  if (port === "3000") o = `http://${document.location.hostname}:1317`;
  else o = window.location.origin;
  return o;
}
